import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './backButton.css';

// Floating "back" button that returns to whichever page the user was on
// before. `location.key` is React Router's own per-navigation-entry id and
// is literally the string "default" only on the very first page load in
// this tab — once the user has navigated anywhere (a link, a redirect,
// browser back/forward), it becomes a unique key. That's used here instead
// of a custom counter so there's nothing to go "back" to when there isn't
// actually a previous in-app page yet.
function BackButton() {
	const navigate = useNavigate();
	const location = useLocation();

	if (location.key === 'default') return null;

	return (
		<button
			type="button"
			className="back-button"
			onClick={() => navigate(-1)}
			aria-label="Go back"
		>
			←
		</button>
	);
}

export default BackButton;
